<a class="grid-event-wrapper" [class.image]="showParticipantImage" [href]="eventUrl" [msRemoveHref]="shouldRemoveHref">
    @if (!showOdds) {
        <div class="grid-info-wrapper">
            @if (showCompetitionLogo && !hideCompetitionLogoOrSportIcon) {
                <ms-competition-logo fallbackIcon="icon sports-{{ event.sport.id }}" [sportId]="event.sport.id" [leagueId]="event.league.id" />
            }

            @if (!showCompetitionLogo && !hideCompetitionLogoOrSportIcon) {
                <vn-icon name="sports-{{ event.sport.id }}" class="sport-icon-alignment" size="16" />
            }

            <div class="grid-event-detail">
                <ms-event-name [event]="event" [showParticipantImage]="showParticipantImage" />
            </div>
            <div
                [ngClass]="{
                    'timer-theme-right': eventsCount === 1,
                    'timer-theme-right-multiple': eventsCount > 1,
                }">
                <ms-event-timer
                    class="grid-event-timer"
                    [live]="event.live"
                    [start]="event.startDate"
                    [scoreboard]="event.scoreboard"
                    [intervalForRedPrematchTimer]="intervalForRedPrematchTimer"
                    [isDynamicTimer]="true" />
                <vn-icon class="next-event-icon-alignment" name="theme-right" size="13" />
            </div>
        </div>
    } @else {
        @if (isWideScreen) {
            <div class="grid-info-wrapper fixed">
                @if (showCompetitionLogo && !hideCompetitionLogoOrSportIcon) {
                    <ms-competition-logo [sportId]="event.sport.id" [leagueId]="event.league.id" />
                }
                @if (!showCompetitionLogo && !hideCompetitionLogoOrSportIcon) {
                    <vn-icon name="sports-{{ event.sport.id }}" class="sport-icon-alignment" size="16" />
                }

                <div class="grid-event-detail">
                    <ms-event-name [event]="event" [showParticipantImage]="showParticipantImage" />
                </div>
            </div>
            <div class="odds-timer-container" [ngClass]="oddsTimerGroupClass">
                <div class="grid-group-container">
                    @if (empty) {
                        <div class="grid-option-group empty">
                            <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="emptyText" />
                        </div>
                    }
                    @if (!empty) {
                        <ms-next-to-go-option-group [optionGroup]="optionGroup" [event]="event" [tracking]="tracking" />
                    }
                </div>
                <div class="timer-theme-right-with-odds">
                    <ms-event-timer
                        class="grid-event-timer"
                        [live]="event.live"
                        [start]="event.startDate"
                        [scoreboard]="event.scoreboard"
                        [intervalForRedPrematchTimer]="intervalForRedPrematchTimer"
                        [isDynamicTimer]="true" />
                    <vn-icon class="right-icon-alignment" name="theme-right" size="13" />
                </div>
            </div>
        } @else {
            <div class="grid-info-wrapper fixed">
                @if (showCompetitionLogo && !hideCompetitionLogoOrSportIcon) {
                    <ms-competition-logo [sportId]="event.sport.id" [leagueId]="event.league.id" [ngClass]="{ 'competition-logo-odds': showOdds }" />
                }
                @if (!showCompetitionLogo && !hideCompetitionLogoOrSportIcon) {
                    <vn-icon name="sports-{{ event.sport.id }}" class="sport-icon-alignment" size="16" [ngClass]="{ 'icon-logo-odds': showOdds }" />
                }

                <div class="grid-event-detail-mobile-with-odds">
                    <ms-event-name [event]="event" [showParticipantImage]="showParticipantImage" />
                    <ms-event-timer
                        class="grid-event-timer-mobile"
                        [live]="event.live"
                        [start]="event.startDate"
                        [scoreboard]="event.scoreboard"
                        [intervalForRedPrematchTimer]="intervalForRedPrematchTimer"
                        [isDynamicTimer]="true"
                        [class.no-participant-image]="showParticipantImage && !hideCompetitionLogoOrSportIcon" />
                </div>
            </div>
            <div class="odds-timer-container" [ngClass]="oddsTimerGroupClass">
                <div class="grid-group-container">
                    @if (empty) {
                        <div class="grid-option-group empty">
                            <ms-font-resizer [defaultSize]="1" [maxChars]="6" [value]="emptyText" />
                            <vn-icon name="theme-right" size="13" />
                        </div>
                    }
                    @if (!empty) {
                        <div class="grid-group-container">
                            <ms-next-to-go-option-group [optionGroup]="optionGroup" [event]="event" [tracking]="tracking" />
                        </div>
                    }
                </div>
            </div>
        }
    }
</a>
